/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import DailyClosingEvent from '../../event/DailyClosingEvent'
import { DailyClosingReservationState } from '../state/DailyClosingReservationState'

class DailyClosingReservationsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case DailyClosingEvent.setReservation:
        let dailyClosingReservation = new DailyClosingReservationState().buildBy(payload.reservation, payload.site_referrer_options, payload.transaction_commissions)
        return state.clear().push(dailyClosingReservation)

      case DailyClosingEvent.addReservation:
        const found = state.findIndex(it => it.reservation_id == payload.reservation.id)
        if (found !== -1) {
          return state
        }
        const r = new DailyClosingReservationState().setReservation(payload.reservation, payload.site_referrer_options)
        return state.push(r)

      case DailyClosingEvent.fetchOne:
        const rs = payload.daily_closing_reservations.map(r => {
          return new DailyClosingReservationState().mergeModel(r)
        })
        return List(rs)

      case DailyClosingEvent.onDeleteReservation:
        const index = state.findIndex(r => r.reservation_id === payload.reservation_id)
        return state.delete(index)

      case DailyClosingEvent.onEditReservation:
        const details = state.setIn([payload.index, payload.name], payload.value)
        return List(details)

      default:
        return state
    }
  }
}

export default new DailyClosingReservationsStore()
